import { Data } from 'signup-constants/signupData/Data';
import { UseCase } from 'signup-constants/signupData/UseCaseOption';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { DataOptions, UseCaseToHubInterest } from '../signup-data/signupDataOptions';
import { useSignupData } from '../signup-data/useSignupData';
import { BaseButtonsView } from './BaseButtonsView';
import { getHighestPriorityUseCase, getHighestPriorityUseCaseCOAC0002 } from '../utils/useCaseUtils';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { jsx as _jsx } from "react/jsx-runtime";
export const isUseCaseButtonDisabled = (data, key) => {
  return data.split(',').length === 3 && !data.includes(key);
};
export const getUseCaseDataWithoutKey = (useCaseData, key) => {
  const useCaseList = useCaseData.split(',');
  const useCaseListWithoutSelectedKey = useCaseList.filter(useCaseKey => useCaseKey !== key);
  const filteredData = useCaseListWithoutSelectedKey.join(',');
  return filteredData;
};
const UseCaseView = () => {
  const dataKey = Data.UseCase;
  const {
    isMobile
  } = useResponsiveness();
  let options = DataOptions[dataKey];
  const {
    data
  } = useSignupData(dataKey);
  const {
    setData: setHubInterest
  } = useSignupData(Data.HubInterest);
  const isSelected = key => {
    return data.includes(key);
  };
  const {
    isAssignedToVariant: isAssignedCOAC0002Variant
  } = useExperiment(ExperimentKeys.COAC0002, TrackWhen.never);
  if (isAssignedCOAC0002Variant()) {
    options = options.filter(val => val !== UseCase.MarketingContent);
  }
  const setDataFn = (key, setData) => {
    let useCaseData = data;
    if (isSelected(key)) {
      useCaseData = getUseCaseDataWithoutKey(useCaseData, key);
    } else if (key === UseCase.StillExploring) {
      useCaseData = UseCase.StillExploring;
    } else {
      useCaseData = getUseCaseDataWithoutKey(useCaseData, UseCase.StillExploring);
      useCaseData = useCaseData ? useCaseData.concat(`,${key}`) : key;
    }
    setData(useCaseData);
  };
  const onSelect = () => {
    const useCases = data.split(',');
    const highestPriorityUseCase = isAssignedCOAC0002Variant() ? getHighestPriorityUseCaseCOAC0002(useCases) : getHighestPriorityUseCase(useCases);
    if (highestPriorityUseCase) {
      const hubInterestMapping = UseCaseToHubInterest[highestPriorityUseCase];
      if (hubInterestMapping) {
        setHubInterest(hubInterestMapping);
      }
    }
  };
  const columnCount = isMobile ? 1 : 2;
  return /*#__PURE__*/_jsx(BaseButtonsView, {
    columnCount: columnCount,
    hasNextButton: true,
    helperTextString: 'views.USE_CASE.helperText',
    isSelected: isSelected,
    options: options,
    setDataFn: setDataFn,
    shouldCenterLastRow: false,
    shouldDisableAutofocus: true,
    type: "checkbox",
    onSelect: onSelect
  });
};
export default UseCaseView;